<template>
  <HeaderV />
  <main class="main">
    <SectionOne />
    <SectionTwo />
    <SectionTrois />
    <!-- <SectionQuatre /> -->
    <!-- <SectionCinq /> -->
    <SectionSix />
  </main>
  <FooterV />
  <!-- <div id="preloader"></div> -->
</template>
  <script lang="ts">
import { defineComponent, onMounted } from "vue";
import HeaderV from "@/components/Landing/HeaderV.vue";
import SectionOne from "@/components/Landing/SectionOne.vue";
import SectionTwo from "@/components/Landing/SectionTwo.vue";
import FooterV from "@/components/Landing/FooterV.vue";
import SectionTrois from "@/components/Landing/SectionTrois.vue";
import SectionQuatre from "@/components/Landing/SectionQuatre.vue";
import SectionCinq from "@/components/Landing/SectionTrois.vue";
import SectionSix from "@/components/Landing/SectionSix.vue";
import { retraitChargement } from "@/utils/utils";

export default defineComponent({
  name: "LandingPage",
  components: {
    SectionTwo,
    HeaderV,
    FooterV,
    SectionOne,
    // SectionQuatre,
    SectionTrois,
    SectionSix,
    // SectionCinq,
  },
  setup: () => {
    onMounted(() => {
      retraitChargement();
    });

    return {};
  },
});
</script>
<style scoped>
h1, h2, h3, h4, h5, h6 {
    color: #fff;
}
</style>